(function($) {
    $.widget("ca.caPhonesGroup", {
        options : {
            name        : 'phones',
            value       : null,
            types       : null,
            defaultType : 'Work',
            separator   : '<br />'
        },
        countPhones: 0,
        unusedOptions: [],
        
        _create : function() {
            var self = this;
            var options = self.options;
            
            for (var i = 0; i < options.types.length; i++) {
                self.unusedOptions.push(options.types[i]);
            }

            if (options.value.length != 0) {
                if (typeof options.value.length === "undefined"){
                    this._addRow(options.value);
                } else {
                    for (var i = 0; i < options.value.length; i++) {
                        this._addRow(options.value[i]);
                    }
                }
            } else {
                this._addRow({type: options.defaultType, value: null});
            }
            
            if (this.element.hasClass('ca-error-field')) {
                this.element.find('.ca-select').addClass('ca-error-field');
                this.element.find('input').addClass('ca-error-field');
            }

            $(this.element).find('.ca-add-phone').bind('click', function() {
                self._addRow();

                return false;
            });
            $(this.element).find('.ca-remove-phone').on('click', function() {
                self.removeRow($(this));
            });
            $(this.element).find('select').on('change', function() {
                self.updateSelectPhoneType();
            });
        },

        _addRow : function (data) {
            var self = this,
                options = this.options;

            if (data == undefined) {
                var data = {};
            }

            var emptyRowSelect = $('<select name="' + options.name + '['+ self.countPhones +'][type]"></select>');
            var emptyRowInput  = $('<input type="text" name="' + options.name + '['+ self.countPhones +'][number]" />');
            var emptyRowRemovePhone = $('<a href="javascript:;"><i class="hi hi-minus"></i>Remove Phone</a>');
            var emptyRow = $('<div></div>');

            if (data.number != undefined) {
                emptyRowInput.val(data.number);
            }

            emptyRowSelect.addClass('group-type').addClass('ca-select');
            emptyRowInput.addClass('group-value').addClass('ca-text-field form-control');
            emptyRowRemovePhone.addClass('ca-remove-phone');
            emptyRowSelect.on('change', function() {
                self.updateSelectPhoneType();
            });
            emptyRow.addClass('group-row ca-pro-ui');
            
            if (options.types) {
                var selectedOption = data.type !== undefined
                    ? data.type
                    : self.unusedOptions.indexOf(self.options.defaultType) !== -1
                        ? self.options.defaultType
                        : self.unusedOptions[0];
                for (var i = 0; i < options.types.length; i++) {
                    var $option = $('<option value="' + options.types[i] + '">'
                            + options.types[i] + '</option>');
                    
                    emptyRowSelect.append($option);
                }
                emptyRowSelect.val(selectedOption);
            }

            emptyRow.append(emptyRowSelect).append(emptyRowInput);
            
            emptyRow.append('<div class="clear"></div>');
            $(this.element).children('.group-data').append(emptyRow);

            emptyRowSelect.caSelect({selectType: 'select'});
        
            if (self.countPhones) {
                var $phoneRows = $(this.element).find('.group-row');
                
                $phoneRows.each(function() {
                    var $removeButton = $(this).find('a.ca-remove-phone');
                    
                    if (!$removeButton.length) {
                        var $newRemoveButton = emptyRowRemovePhone.clone();
                        
                        $newRemoveButton.on('click', function() {
                            self.removeRow($(this));
                        });
                        $(this).append($newRemoveButton);
                    }
                });
            }

            self.updateSelectPhoneType();
            
            if (self.unusedOptions.length === 0) {
                self.element.find('.ca-add-phone').hide();
            }
        },
        
        removeRow: function($removeButton) {
            var self = this;
            
            $removeButton.parents('.group-row').remove();
            self.updateSelectPhoneType();
            self.element.find('.ca-add-phone').show();
        },
        
        updateSelectPhoneType: function() {
            var self = this,
                selects = self.element.find('select'),
                disabledOptions = $('option[disabled=disabled]');
        
            self.unusedOptions = [];
        
            disabledOptions.each(function() {
                $(this).removeAttr('disabled');
            });
            
            selects.each(function() {
                var selected = $(this).val();
                
                selects.each(function() {
                    $(this).find('option[value=' + selected + ']')
                        .attr('disabled', 'disabled');
                });
                
                $(this).find('option').removeAttr('selected');
                $(this).find('option[value=' + selected + ']')
                    .removeAttr('disabled', 'disabled')
                    .attr('selected', 'selected');
            });
            
            selects.each(function() {
                $(this).caSelect('reset');
            });
            
            for (var i = 0; i < self.options.types.length; i++) {
                var $options = $('#phones')
                    .find('option[value=' + self.options.types[i] + ']:selected');
            
                if (!$options.length) {
                    self.unusedOptions.push(self.options.types[i]);
                }
            }
            
            self.countPhones = self.options.types.length - self.unusedOptions.length;

            if (self.countPhones === 1) {
                $(this.element).find('a.ca-remove-phone').remove();
            }
        }
    });
})(jQuery);
